
import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { ArcaDate } from '../../code/Types/ArcaDate';

export class UnitTestArcaDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usefulText: null
        };
    }

    componentDidMount() {
        var date = new ArcaDate((new Date("2020-2-3")).getTime());

        this.ArcaDate_Month_Test(date);
        this.ArcaDate_Year_Test(date);
        this.ArcaDate_DateFromDay_Test(date, 4);
        this.ArcaDate_Day_Test(date);
        this.ArcaData_IsLater_Test(date);
        this.ArcaDate_AddMonth_Test(date);
        this.ArcaDate_DayOfWeek_Test(date);
        this.ArcaDate_DayOfYear_Test(date);
        this.ArcaDate_DaysInMonthList_Test(date);
        this.ArcaDate_DaysInMonth_Test(date);
        this.ArcaDate_GetWeekStart_Test(date);
    }

    ArcaDate_GetWeekStart_Test(date) {
        var startOfWeek = date.GetWeekStart;

        var result = date.DayOfWeek === 'Sunday'
            && date.Year === startOfWeek.Year
            && date.Month === startOfWeek.Month
            && date.Day === 2

        this.setState({
            ArcaDateGetWeekStartTestOk: result,
            usefulText: result ? 'OK' : date.DayOfWeek
        });
    }

    ArcaDate_AddMonth_Test(date) {
        var laterDate = date.AddMonth(1);

        var result = date.Day === laterDate.Day
            && date.Year === laterDate.Year
            && date.Month === laterDate.Month - 1

        this.setState({
            ArcaDateAddMonthTestOk: result,
            usefulText: result ? 'OK' : date.DayOfWeek
        });
    }

    ArcaDate_DateFromDay_Test(oldDate, day) {

        var newDate = oldDate.DateFromDay(day);
        var result = newDate.DayOfWeek === 'Saturday'
            && newDate.Month === oldDate.Month
            && newDate.Year === oldDate.Year;

        this.setState({
            ArcaDateDayOfWeekTestOk: result,
            usefulText: result ? 'OK' : newDate.DayOfWeek
        });
    }

    ArcaDate_DayOfWeek_Test(date) {
        var result = date.DayOfWeek === 'Monday'

        this.setState({
            ArcaDateDayOfWeekTestOk: result,
            usefulText: result ? 'OK' : date.DayOfWeek
        });
    }

    ArcaDate_DayOfYear_Test(date) {
        var result = date.MonthOfYear === 'February'

        this.setState({
            ArcaDateDayOfYearTestOk: result,
            usefulText: result ? 'OK' : date.MonthOfYear
        });
    }

    ArcaDate_DaysInMonth_Test(date) {
        var result = date.DaysInMonth === 29

        this.setState({
            ArcaDateDaysInMonthTestOk: result,
            usefulText: result ? 'OK' : date.DaysInMonth
        });
    }

    ArcaDate_Day_Test(date) {
        var result = date.Day === 3

        this.setState({
            ArcaDateDayTestOk: result,
            usefulText: result ? 'OK' : date.Day
        });
    }

    ArcaData_IsLater_Test(date) {
        var laterDate = date.AddMonth(1);
        var result = date.IsLater(laterDate);

        this.setState({
            ArcaIsLaterTestOk: result,
            usefulText: result ? 'OK' : 'isLater'
        });
    }

    ArcaDate_Month_Test(date) {
        var result = date.Month === 2

        this.setState({
            ArcaDateMonthTestOk: result,
            usefulText: result ? 'OK' : date.Month
        });
    }

    ArcaDate_Year_Test(date) {
        var result = date.Year === 2020

        this.setState({
            ArcaDateYearTestOk: result,
            usefulText: result ? 'OK' : date.Year
        });
    }

    ArcaDate_DaysInMonthList_Test(date) {
        var len = date.DaysInMonth;
        var result = date.DaysInMonthList.length === len
            && date.DaysInMonthList[0] === 1
            && date.DaysInMonthList[len - 1] === len

        this.setState({
            ArcaDateDaysInMonthListTestOk: result,
            usefulText: result ? 'OK' : date.DaysInMonth
        });
    }

    /*eslint-disable */
    render() {
        return (
            <div>
                <Alert color="secondary">
                    {this.state.usefulText
                        ? <div>{this.state.usefulText}</div>
                        : "blank"}
                </Alert>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>ArcaDate</th>
                            <th>Result</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>ArcaDate_AddMonth_Test</td>
                            {this.state.ArcaDateAddMonthTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaDateDayOfWeekTest</td>
                            {this.state.ArcaDateDayOfWeekTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaDateDaysInMonthTest</td>
                            {this.state.ArcaDateDaysInMonthTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaDateDayOfYearTest</td>
                            {this.state.ArcaDateDayOfYearTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaDateDayTest</td>
                            {this.state.ArcaDateDayTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaDateMonthTest</td>
                            {this.state.ArcaDateMonthTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaDateYearTest</td>
                            {this.state.ArcaDateYearTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaDateDaysInMonthListTest</td>
                            {this.state.ArcaDateDaysInMonthListTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaDateDaysInMonthListTest</td>
                            {this.state.ArcaDateDaysInMonthListTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaIsLaterTest</td>
                            {this.state.ArcaIsLaterTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaDate_GetWeekStart_Test</td>
                            {this.state.ArcaDateGetWeekStartTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                    </tbody>
                </table>
            </div >
        );
    }
}
